<template>
    <b-modal
        v-if="entity"
        v-model="modal.state"
        :footer-class="{
            'p-3 p-sm-4': true,
            'justify-content-end': !isMobile,
            'row flex-nowrap m-0': isMobile,
        }"
        :header-class="{
            'border-bottom pr-3 pl-0 py-2': isMobile,
        }"
        dialog-class="property-saved-searches-share-modal"
        body-class="px-3 px-sm-4"
        size="lg"
        title="Share with Member"
        :hide-header-close="!isMobile"
        no-close-on-backdrop
        no-close-on-esc
        scrollable
        @ok="handleOk"
        @cancel="handleClose"
        @close="handleClose"
    >
        <template v-slot:modal-header-close>
            <i class="far fa-arrow-left text-gray-700" />
        </template>
        <project-members-type-ahead
            v-model="projectMembers"
            class="mb-2"
        />

        <project-member-item
            class="border-bottom"
            v-for="member in projectMembers"
            :key="member.uuid"
            :project-member-app-resource="member"
            @remove="handleRemoveEvent"
        />

        <template v-slot:modal-footer="{ ok, cancel }">
            <template v-if="isMobile">
                <b-col
                    cols="5"
                    class="m-0 p-0"
                >
                    <b-button
                        variant="transparent"
                        size="lg"
                        block
                        @click="cancel"
                    >
                        Cancel
                    </b-button>
                </b-col>
                <b-col
                    cols="7"
                    class="m-0 p-0"
                >
                    <b-button
                        variant="primary"
                        size="lg"
                        block
                        @click="ok"
                    >
                        Share
                    </b-button>
                </b-col>
            </template>
            <template v-else>
                <b-button
                    variant="transparent"
                    size="lg"
                    @click="cancel"
                >
                    Cancel
                </b-button>
                <b-button
                    variant="primary"
                    size="lg"
                    class="px-5"
                    @click="ok"
                >
                    Share
                </b-button>
            </template>
        </template>
    </b-modal>
</template>

<script>
    import './PropertySavedSearchesShareModal.scss';
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import {AppResourceCollection} from "@milestoneslabs/milestones-js-engine";

    import ProjectMembersTypeAhead from '../ProjectMembersTypeAhead/ProjectMembersTypeAhead';
    import ProjectMemberItem from '../ProjectMembersTypeAhead/ProjectMemberItem/ProjectMemberItem';

    export const PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY = 'PropertySavedSearchesShareModal:display';

    export default {
        name: "PropertySavedSearchesShareModal",

        components: {
            ProjectMembersTypeAhead,
            ProjectMemberItem,
        },

        mixins: [
            ShowNotificationMixin,
            IsMobileMixin,
        ],

        data() {
            return {
                modal: {
                    state: false,
                },
                entity: null,
                event: null,
                emitClosed: false,
                projectMembers: [],
            };
        },

        async beforeMount() {
            this.$bus.$on(PROPERTY_SAVED_SEARCHES_SHARE_MODAL_DISPLAY, async ({entity, event, emitClosed}) => {
                if (!(entity instanceof AppResourceCollection)) {
                    throw new Error('Invalid payload, entity should be an instance of AppResourceCollection');
                }
                if (emitClosed) {
                    this.emitClosed = emitClosed;
                }
                this.init(entity, event);
            });
        },

        methods: {
            async init(entity, event) {
                this.event = event;
                this.entity = entity;
                this.projectMembers = entity.toArray();
                this.modal.state = true;
            },

            handleRemoveEvent(projectMember) {
                this.projectMembers = this.projectMembers.filter(item => {
                    return item.uuid !== projectMember.uuid;
                });
            },

            handleOk() {
                this.$bus.$emit(this.event, this.projectMembers);
            },

            handleClose() {
                if (this.emitClosed) {
                    this.handleOk();
                }
                this.entity = null;
                this.event = null;
                this.emitClosed = false;
                this.projectMembers = [];
            }
        }
    };
</script>
